import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { UndoOutlined, UploadOutlined } from '@ant-design/icons';

import { Card, Row, Col, Upload, Button, Progress, notification, Typography } from 'antd';
import { FormikButton } from '../../Components/Formik';

import ProdOrdExcel01Actions from '../../Stores/ProdOrdExcel01/Actions';

const { Text } = Typography;

class ProdOrdExcel01Form extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      hdrFile: [],
      dtlFile: []
    };

    this.useOnUpload = this.useOnUpload.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate() {
    const { uploadIsLoading, showBatchJobStatus } = this.props;

    if (uploadIsLoading) {
      setTimeout(() => {
        showBatchJobStatus();
      }, 10000);
    }
  }

  componentWillUnmount() {}

  useOnUpload(values, formikBag) {
    const { uploadExcel } = this.props;
    const { hdrFile, dtlFile } = this.state;

    if (hdrFile.length > 0 && dtlFile.length > 0) {
      uploadExcel(formikBag, hdrFile[0], dtlFile[0]);
    }
  }

  render() {
    const { intl, uploadIsLoading, batchJobStatus } = this.props;
    const { hdrFile, dtlFile } = this.state;

    return (
      <Card>
        <Formik enableReinitialize onSubmit={this.useOnUpload}>
          {({
            // values,
            // handleChange,
            // errors,
            // setFieldTouched,
            dirty,
            // touched,
            isSubmitting,
            // isValid,
            handleSubmit,
            handleReset
          }) => (
            <Form>
              <Row type="flex" justify="start" gutter={[0, 8]}>
                <Col span={3}>
                  <Text>{intl.formatMessage({ id: 'header_file' })}</Text>
                </Col>
                <Col span={1}>
                  <Text>:</Text>
                </Col>
                <Col span={12}>
                  <Upload
                    disabled={uploadIsLoading}
                    onRemove={() => {
                      this.setState({
                        hdrFile: []
                      });
                    }}
                    beforeUpload={file => {
                      const validFileName1 = 'ASSEMBLY';
                      if (file && file.name.toUpperCase().includes(validFileName1)) {
                        this.setState({
                          hdrFile: [file]
                        });
                      } else {
                        notification.error({
                          message: `${intl.formatMessage({
                            id: 'invalid_file_name_must_contain'
                          })} ${validFileName1}`,
                          duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
                        });
                      }

                      return false;
                    }}
                    fileList={hdrFile}
                  >
                    <Button type="primary" loading={uploadIsLoading}>
                      {intl.formatMessage({ id: 'browse' })}
                    </Button>
                  </Upload>
                </Col>
              </Row>

              <Row type="flex" justify="start" gutter={[0, 8]}>
                <Col span={3}>
                  <Text>{intl.formatMessage({ id: 'detail_file' })}</Text>
                </Col>
                <Col span={1}>
                  <Text>:</Text>
                </Col>
                <Col span={12}>
                  <Upload
                    disabled={uploadIsLoading}
                    onRemove={() => {
                      this.setState({
                        dtlFile: []
                      });
                    }}
                    beforeUpload={file => {
                      const validFileName1 = 'ASSEMBLY';
                      if (file && file.name.toUpperCase().includes(validFileName1)) {
                        this.setState({
                          dtlFile: [file]
                        });
                      } else {
                        notification.error({
                          message: `${intl.formatMessage({
                            id: 'invalid_file_name_must_contain'
                          })} ${validFileName1}`,
                          duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
                        });
                      }

                      return false;
                    }}
                    fileList={dtlFile}
                  >
                    <Button type="primary" loading={uploadIsLoading}>
                      {intl.formatMessage({ id: 'browse' })}
                    </Button>
                  </Upload>
                </Col>
              </Row>

              <Row type="flex" justify="start" gutter={[0, 16]}>
                <Col span={6}>
                  <Button
                    type="primary"
                    disabled={!dirty}
                    loading={isSubmitting}
                    onClick={handleReset}
                    icon={<UndoOutlined />}
                  >
                    {intl.formatMessage({ id: 'reset' })}
                  </Button>
                  <Field
                    type="primary"
                    name="upload_action"
                    value="update"
                    component={FormikButton}
                    loading={isSubmitting}
                    onClick={handleSubmit}
                    label={intl.formatMessage({
                      id: 'upload'
                    })}
                    icon={<UploadOutlined />}
                    disabled={hdrFile.length === 0 || dtlFile.length === 0}
                  />
                </Col>
              </Row>
              <Row type="flex" justify="center" gutter={[0, 8]}>
                <Col span={24}>
                  <Progress percent={parseInt(batchJobStatus.status_number, 10)} />
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card>
    );
  }
}

ProdOrdExcel01Form.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  batchJobStatus: PropTypes.shape({
    status_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  uploadIsLoading: PropTypes.bool,

  showBatchJobStatus: PropTypes.func,
  uploadExcel: PropTypes.func
};

ProdOrdExcel01Form.defaultProps = {
  intl: {},

  batchJobStatus: {
    status_number: '0'
  },
  uploadIsLoading: false,

  showBatchJobStatus() {},
  uploadExcel() {}
};

const mapStateToProps = state => ({
  batchJobStatus: state.prodOrdExcel01.batchJobStatus,
  uploadIsLoading: state.prodOrdExcel01.uploadIsLoading
});

const mapDispatchToProps = dispatch => ({
  showBatchJobStatus: () => dispatch(ProdOrdExcel01Actions.prodOrdExcel01ShowBatchJobStatus()),
  uploadExcel: (formikBag, hdrFile, dtlFile) =>
    dispatch(ProdOrdExcel01Actions.prodOrdExcel01UploadExcel(formikBag, hdrFile, dtlFile))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProdOrdExcel01Form));
